// Is `to` the nav entry for the page at `pathname`?
//
// A section stays selected on its detail pages — /blog/my-post keeps "Blog"
// marked, /tools/termbrowser keeps "Tools" — so the header always says which
// part of the site you're in, not just which URL you typed. Matching on the
// path boundary rather than a bare prefix keeps a hypothetical /toolset from
// lighting up /tools.
//
// Only for internal routes; external nav entries (Chat, Docs) are never
// "current" because you're never on them.
export const isActiveNavPath = (pathname, to) => {
  if (!pathname || !to)
    return false;
  if (to === '/')
    return pathname === '/';
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return normalized === to || normalized.startsWith(`${to}/`);
};
